import React, { useRef, useState, useEffect } from "react";
import { useLockFn } from "ahooks";
import { YhForm } from "@components/YhFormBox";
import { YHDrawer } from "@src/components/YhDrawer";
import { globalPrompt } from "@src/components/YhMessage";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@components/YhFormBox/Types";
import { getBaseImgUploadUrl, getBaseUploadData, getBaseImgLookUrl } from "@src/utils/constants";
import { rosterDetailsModels } from "./rosterDetailsModels";
import { rosterService } from "../../rosterService";
import YhUploadForm from '@src/components/YhUploadForm';
import useGlobalModel from "@src/model/globalModel";
import moment from "moment";

export const ContractRenewDrawer: React.FC<{
  visible: boolean;
  userInfo: any;
  onCancel: () => void;
}> = ({ visible, userInfo, onCancel }) => {
  const { user } = useGlobalModel()
  const {
    contraceHoldTypeDs, contraceTypeDs, socialSecurityTypeDs,
    contract, contracts, setContracts,
  } = rosterDetailsModels();

  const formRef = useRef<IYhFormRef>();
  const formConfig: IYhForm = {
    formRef,
    labelCol: { span: 9 },
    disabled: false,
    initialValues: { ...contract, staffId: userInfo?.staffId, name: userInfo?.name },
    justify: "start",
    items: [
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "员工工号",
        fieldName: "staffId",
        span: 12,
        rules: [{ required: true, message: "该项为必选项" }],
        disable: true,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "员工姓名",
        fieldName: "name",
        span: 12,
        rules: [{ required: true, message: "该项为必选项" }],
        disable: true,
      },
      {
        type: FormItemTypeEnum.Select,
        fieldLabel: "社保户别",
        fieldName: "socialSecurityType",
        span: 12,
        disable: true,
        ds: socialSecurityTypeDs,
      },
      {
        type: FormItemTypeEnum.Select,
        fieldLabel: "是否长期",
        fieldName: "isLongTerm",
        span: 12,
        ds: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
        disable: true,
      },
      {
        type: FormItemTypeEnum.Select,
        fieldLabel: "合同类型",
        fieldName: "contractType",
        span: 12,
        rules: [{ required: true, message: "该项为必选项" }],
        ds: contraceTypeDs,
      },
      {
        type: FormItemTypeEnum.Select,
        fieldLabel: "合同户别",
        fieldName: "contractCategory",
        span: 12,
        rules: [{ required: true, message: "该项为必选项" }],
        ds: contraceHoldTypeDs,
        style: { width: 196 }
      },
      {
        type: FormItemTypeEnum.Datepicker,
        format: "YYYY-MM-DD",
        fieldLabel: "合同开始时间",
        fieldName: "startDate",
        span: 12,
        rules: [{ required: true, message: "该项为必选项" }],
      },
      {
        type: FormItemTypeEnum.Datepicker,
        format: "YYYY-MM-DD",
        fieldLabel: "合同结束时间",
        fieldName: "endDate",
        span: 12,
        rules: [{ required: true, message: "该项为必选项" }],
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "合同期限",
        fieldName: "contractDuration",
        span: 12,
        rules: [{ required: true, message: "该项为必选项" }],
      },
      {
        type: FormItemTypeEnum.Other,
        fieldLabel: "相关文件",
        fieldName: "file",
        span: 12,
        formItem:
          <div className="userFileStyle">
            <YhUploadForm
              name="fileList"
              label="相关文件"
              maxCount={1}
              listType={"picture-card"}
              fileUrl={getBaseImgUploadUrl}
              action={getBaseImgUploadUrl()}
              uploadData={getBaseUploadData()}
            />
          </div>
      },
    ],
  };

  const onRenew = useLockFn(async () => {
    try {
      const formData = await formRef.current?.validateFields();
      //formData追加到contracts中
      const contractsData = [...contracts, {
        ...formData,
        num: contract.num + 1,
        probationSalary: contract.probationSalary,
        operator: user.userName,
        userFileList: formData?.fileList?.map((item: any) => ({ imgUrl: item.uid, imgName: item.name })),
      }];
      if (formData) {
        const params = {
          employeeId: userInfo.id,
          userContractsInsertVoList: contractsData?.map((item: any) => ({
            ...item,
            startDate: item.startDate ? moment(item.startDate).format("YYYY-MM-DD") : null,
            endDate: item.endDate ? moment(item.endDate).format("YYYY-MM-DD") : null,
          }))
        }
        let ret = await rosterService.contractInsert(params);
        if (ret.success) {
          await globalPrompt("message", { type: "success", text: '保存成功!' });
          onCancel();
        } else {
          await globalPrompt("message", { type: "error", text: "保存失败!" + ret.retMsg });
        }
      }
    } catch (e) {
      console.log("续签失败!", e);
    }
  });

  return (
    <YHDrawer
      {...{
        title: "合同续签",
        visible,
        onOk: () => { onRenew() },
        onCancel,
        width: 680,
        showFooter: true,
        okText: "确定",
        cancelText: "关闭",
      }}
    >
      <YhForm {...formConfig} />
    </YHDrawer>
  );
};
